var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('idc-component-adjustment-permission-summary',{attrs:{"can-create":_vm.canCreate,"can-edit":_vm.canEdit,"can-delete":_vm.canDelete}})
}
var staticRenderFns = []

export { render, staticRenderFns }